/* eslint global-require:0 */
/* globals window console require */
import { isEmpty } from 'lodash';

/**
 * Fetch config depending on build type
 * Development: webpack-dev-server defined in webpack/webpack.config.dev.js
 * Production:  express server defined in tests/server/index.js
 */
fetch('/config.json')
  .then(res => res.json())
  .then(({ config }) => {
    const hostName = window.location.hostname;
    if (!isEmpty(config.affiliateDomainToRegion[hostName])) {
      const { region } = config.affiliateDomainToRegion[hostName];
      if (
        !isEmpty(region) &&
        !isEmpty(config.regionalConfigs) &&
        !isEmpty(config.regionalConfigs[region])
      ) {
        window.regionalAffiliateCodes = Object.entries(
          config.affiliateDomainToRegion
        ).map(domain => domain[1].affiliateCode);
        window.trilogyConfig = config.regionalConfigs[region];
        window.sessionTimeoutMs = config.sessionTimeoutMs || 30 * 60 * 1000; // 30 minute default if config not set
        window.bannerMessage = config.bannerMessage;
        window.modalMessage = config.modalMessage;

        // Store region and private config endpoint for API key fetch
        window.currentRegion = region;
        window.privateConfigEndpoint = config.privateConfigEndpoint;

        return Promise.resolve();
      }
    }
    console.log('Config is invalid or missing.');
    return Promise.reject();
  })
  .then(() => {
    // After config is loaded, fetch API keys from authenticated endpoint
    // Import dynamically to avoid circular dependency issues
    return import('./config/auth').then(({ isLoggedIn }) => {
      if (isLoggedIn()) {
        console.log('User is logged in, fetching API keys...');
        return import('./config/fetchApiKeys').then(
          ({ default: fetchApiKeys, mergeApiKeysIntoConfig }) => {
            return fetchApiKeys(window.currentRegion)
              .then(apiKeys => {
                mergeApiKeysIntoConfig(apiKeys);
                return Promise.resolve();
              })
              .catch(error => {
                console.error('Failed to fetch API keys:', error);
                // Continue anyway - some services might work without API keys
                // Or you can reject here to show an error page
                return Promise.resolve();
              });
          }
        );
      } else {
        console.log('User not logged in yet, skipping API key fetch');
        return Promise.resolve();
      }
    });
  })
  .then(() => require('./App'))
  .catch(() => require('./NoConfigApp'));
